import '../vendor';

import '../general/ofi';
import '../general/search';
import '../general/hamburger';
import '../general/menu';
import '../general/breadcrumbs';
import '../general/anchor';
import '../general/full-screen';
import '../general/warning';
import '../general/up';

import '../pages/one-museum/museum-calendar';
import '../pages/one-museum/museum-filter';
import '../pages/one-museum/museum-media';
import '../pages/one-museum/museum-masonry';
import '../pages/one-museum/museum-reviews';
import '../pages/one-museum/museum-share';
import '../pages/one-museum/museum-title';
import '../pages/one-museum/museum-close-slider';
import '../pages/one-museum/museum-routes-slider';
import '../pages/one-museum/museum-events-slider';
import '../pages/one-museum/museum-news-slider';
import '../pages/one-museum/museum-reviews-slider';

import '../visually-impaired/open';
import '../visually-impaired/click';
import '../visually-impaired/size';
import '../visually-impaired/color';
import '../visually-impaired/length';
import '../visually-impaired/image';


// WEBPACK FOOTER //
// ./src/js/pages/one-museum.js